module.exports = __webpack_public_path__ + "static/media/Raffrollo_35627_80x160.fc36b895.png";